// extracted by css-extract-rspack-plugin
export default {"cls1":"LettersModal-cls1_TdI","cls2":"LettersModal-cls2_1kt LettersModal-cls1_TdI"};